<div class="content">
  <div class="title" translate="parameters/kakaotalk-templates/preview/title"></div>
  <div class="kakaotalk-message">
    <div class="title-kakao-talk">KakaoTalk</div>
    <div class="header media-wrapper" *ngIf="imageSrc">
      <img [appJwtSrc]="imageSrc" />
    </div>
    <div class="body">
      <p class="body-formatted">{{ bodyFormatted }}</p>
    </div>
    <div class="footer">
      <div class="buttons">
        <div [matTooltip]="button.url" class="button" *ngFor="let button of buttons">
          <a [href]="button.url" target="_blank" rel="noopener noreferrer">
            {{ button.text }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
